(function(){
  'use strict';

  if (!window.fetch || window.__BGC_FULLCART_LINE_FIX_2026__) return;
  window.__BGC_FULLCART_LINE_FIX_2026__ = true;

  var nativeFetch = window.fetch;

  function isPhone(){
    return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
  }

  function isCartChange(input){
    var url = '';
    if (typeof input === 'string') url = input;
    else if (input && input.url) url = input.url;
    return /\/cart\/change\.js(?:[?#]|$)/.test(url);
  }

  function cartJsonUrl(){
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    return root + 'cart.js';
  }

  function currentLineForKey(key){
    if (!key) return 0;
    var rows = Array.prototype.slice.call(document.querySelectorAll('.cart_items .cart-item'));
    for (var i = 0; i < rows.length; i++) {
      if ((rows[i].getAttribute('data-bgc-key') || '') === key) return i + 1;
    }
    return 0;
  }

  function cloneInit(init, payload){
    var revised = {};
    for (var prop in init) {
      if (Object.prototype.hasOwnProperty.call(init, prop)) revised[prop] = init[prop];
    }
    revised.body = JSON.stringify(payload);
    return revised;
  }

  function retryRemovalWithFreshKey(input, init, line){
    return nativeFetch.call(window, cartJsonUrl(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function(response){
      if (!response.ok) throw new Error('Cart read failed');
      return response.json();
    }).then(function(cart){
      var item = cart && cart.items && cart.items[line - 1];
      if (!item || !item.key) throw new Error('Cart line unavailable');
      return nativeFetch.call(window, input, cloneInit(init, {
        id: item.key,
        quantity: 0
      }));
    });
  }

  window.fetch = function(input, init){
    if (!isPhone() || !document.querySelector('#cart_form') || !isCartChange(input) || !init || typeof init.body !== 'string') {
      return nativeFetch.apply(window, arguments);
    }

    var payload;
    try {
      payload = JSON.parse(init.body);
    } catch (_e) {
      return nativeFetch.apply(window, arguments);
    }

    if (!payload || !payload.id || payload.line != null) {
      return nativeFetch.apply(window, arguments);
    }

    var line = currentLineForKey(String(payload.id));
    if (!line) return nativeFetch.apply(window, arguments);

    var revisedPayload = {};
    for (var key in payload) {
      if (Object.prototype.hasOwnProperty.call(payload, key)) revisedPayload[key] = payload[key];
    }
    revisedPayload.line = line;
    delete revisedPayload.id;

    var request = nativeFetch.call(window, input, cloneInit(init, revisedPayload));

    if (Number(revisedPayload.quantity) !== 0) return request;

    return request.then(function(response){
      if (response.ok) return response;
      return retryRemovalWithFreshKey(input, init, line).catch(function(){
        return response;
      });
    });
  };
})();
